import tsCode from "./tsCode";
const reqText = `
{
  query:{}, // url参数
  body:{}   // post请求包体
}
`.trim();
export const requestParamSchema = {
  id: 'params',
  title: '自定义请求参数，最高优先级',
  required: false,
  type: 'object',
  default: reqText,
  description: tsCode(reqText)
};
export const requestResultSchema = {
  description: '接口返回的数据'
};
export function getRequestParamSchema(required) {
  return {
    id: 'params',
    title: '请求参数',
    type: 'object',
    required,
    default: reqText,
    description: tsCode(reqText)
  };
}
//# sourceMappingURL=requestParamSchema.js.map
